import PostgresIcon from "../../assets/components/sources/PostgresqlIcon";

const PostgresLogomark = ({ height }: { height: number }) => {
  return <PostgresIcon height={height} />;
};

export default PostgresLogomark;
